import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebsiteEnquiry } from '@contracts/interfaces/website-enquiry.interface';
import { ConnectionService } from './connection.service';

@Injectable({
  providedIn: 'root'
})
export class WebsiteEnquiryService {

  constructor(
    private http: HttpClient,
    private connectionService: ConnectionService) {}

  find(query: any = {}) {
    return this.http.post(this.connectionService.address + "/website-enquiry-service/find", { query });
  }

  getInfo() {
    return this.http.post(this.connectionService.address + "/website-enquiry-service/get-info", {});
  }

  update(enquiry: WebsiteEnquiry) {
    return this.http.post(this.connectionService.address + "/website-enquiry-service/update", { enquiry });
  }
}
